import { useEffect } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * This is a temporary fix for an issue with tab navigation.
 * @see: https://github.com/react-navigation/react-navigation/issues/10481#issuecomment-1117625967
 */
export const useEmptyPageTabNavigationFix = () => {
  const shouldUseAuthFlowRework = useFeatureFlag(
    'cels-763-short-rework-the-authentication-redirect-flow-enabled',
  );

  useEffect(() => {
    if (shouldUseAuthFlowRework) return;

    if (!window?.history?.pushState) return;
    window.history.pushState({}, '');
    window.history.pushState({}, '');
  }, [shouldUseAuthFlowRework]);
};
